import { Component, OnInit, inject } from '@angular/core';
import {DataService} from "../../../services/data.service";
import {LocalStorageService} from "../../../services/local-storage.service";
import {RouterLink} from "@angular/router";
import {NgForOf, NgIf} from "@angular/common";
import {PaginationComponent} from "ngx-bootstrap/pagination";
import {FormsModule} from "@angular/forms";
import {DebounceKeyupDirective} from "../../../directives/debounce-keyup.directive";

@Component({
    selector: 'app-contact-list',
    templateUrl: './contact-list.component.html',
    imports: [
        RouterLink,
        NgIf,
        NgForOf,
        PaginationComponent,
        FormsModule,
        DebounceKeyupDirective
    ],
    styleUrl: './contact-list.component.scss'
})
export class ContactListComponent implements OnInit {

    private dataService = inject(DataService);
    private localStorageService = inject(LocalStorageService);

    paginConfig;
    entries;
    totalEntries;
    predicate;
    search;
    reverse;

    ngOnInit(): void {
        this.search = {
            name: '',
            zip: '',
            city: '',
            street: '',
            phone: '',
        };

        let searchSaved = this.localStorageService.getItem('contact-list');
        if (searchSaved) {
            this.search = {...this.search, ...searchSaved}
        }

        this.paginConfig = {
            itemsPerPage: 25,
            page: 1
        };
        this.reverse = false;
        this.totalEntries = 0;
        this.predicate = 'name';
        this.listEntries(this.paginConfig);
    }

    setOrder(order): void {
        this.predicate = order;
        this.reverse = !this.reverse;
        this.paginConfig.page = 1;
        this.listEntries(this.paginConfig);
    }

    checkFilterAndList(): void {
        this.localStorageService.setItem('contact-list', this.search);

        this.paginConfig.page = 1;
        this.listEntries(this.paginConfig);
    }

    listEntries(event): void {
        this.paginConfig = event;

        this.entries = null;
        this.dataService.request('Contact/listAll', {
            page: this.paginConfig.page,
            limit: this.paginConfig.itemsPerPage,
            order: this.predicate,
            reverse: this.reverse,
            search: this.search,
        }).subscribe(response => {
            this.totalEntries = response.total;
            this.entries = response.contacts;
        });
    }

}
